import * as z from "zod/v4";

export const upsertRechargeIntegration = {
  name: "upsertRechargeIntegration" as const,
  input: z.object({ apiToken: z.string(), clientSecret: z.string() }),
  output: z.object({ success: z.boolean() }),
};
